export const Icon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_922_67945)">
        <path d="M1.82368 7.79116C1.18835 8.50072 1.17468 9.57125 1.75777 10.3243C2.91484 11.8187 4.18127 13.0852 5.67567 14.2422C6.42875 14.8253 7.49928 14.8116 8.20884 14.1763C10.1353 12.4514 11.8996 10.6487 13.6022 8.6677C13.7705 8.47185 13.8758 8.2318 13.8994 7.97463C14.0039 6.83739 14.2186 3.56096 13.3288 2.67117C12.439 1.78138 9.16261 1.99605 8.02537 2.10055C7.7682 2.12418 7.52815 2.22948 7.3323 2.39781C5.35128 4.10042 3.54861 5.86467 1.82368 7.79116Z" stroke="#2D2D2D"/>
        <path d="M5.0026 9.66602L6.33594 10.9993" stroke="#2D2D2D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.0052 3.99967L14.6719 1.33301" stroke="#2D2D2D" stroke-width="1.25" stroke-linecap="round"/>
        </g>
        <defs>
        <clipPath id="clip0_922_67945">
        <rect width="16" height="16" fill="white"/>
        </clipPath>
        </defs>
        </svg>
    );
};
